var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_tag-user",
    "data-name": "vuesax/twotone/tag-user",
    transform: "translate(-556 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-user",
    transform: "translate(556 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.875,30.208H25.513a5.353,5.353,0,0,0-3.8,1.559l-3.064,3.028a3.623,3.623,0,0,1-5.07,0l-3.064-3.028a5.384,5.384,0,0,0-3.8-1.559H5.375A5.345,5.345,0,0,1,0,24.886V5.321A5.345,5.345,0,0,1,5.375,0h21.5A5.345,5.345,0,0,1,32.25,5.321V24.868A5.36,5.36,0,0,1,26.875,30.208Z",
    transform: "translate(5.375 3.583)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.637,6.987H3.368A3.495,3.495,0,1,1,6.988,3.494,3.446,3.446,0,0,1,3.637,6.987Z",
    transform: "translate(17.988 9.048)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.787,1.344C-.6,2.938-.6,5.536,1.787,7.131a9.622,9.622,0,0,0,9.854,0c2.383-1.595,2.383-4.192,0-5.787A9.7,9.7,0,0,0,1.787,1.344Z",
    transform: "translate(14.786 20.085)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H43V43H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.59de8a664932c5db8d02788c9df40eeb.svg";
export { ForwardRef as ReactComponent };